import React, {memo} from 'react'

const Player = ({file}) => {
  return <video src={URL.createObjectURL(file)} className='w-100' controls />
}

export default memo(Player)